import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  ApexChart,
  ChartComponent,
  ApexTooltip,
  ApexAxisChartSeries,
  ApexPlotOptions,
  ApexFill,
  ApexStroke,
  NgApexchartsModule,
  ApexDataLabels,
  ApexLegend,
  ApexGrid,
  ApexXAxis,
  ApexYAxis,
  ApexNonAxisChartSeries,
  ApexResponsive,
} from 'ng-apexcharts';


export type stackedColumnOption = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  responsive: ApexResponsive[];
  xaxis: ApexXAxis;
  legend: ApexLegend;
  fill: ApexFill;
};



@Component({
  selector: 'app-stackedchart',
  templateUrl: './stackedChart.component.html',
})
export class AppStackedChartComponent implements OnInit {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);
  params;
  salesPerday: Number = 0
  countPerDay: Number = 0

  @Input() salesDataGraph: Array<any> = []
  @Input() categories: Array<any> = []
  @Input() showDataLabels: boolean = true;

  public stackedChart: Partial<stackedColumnOption>;


  constructor() {


   
  }
  async ngOnInit(): Promise<any> {
    this.stackedChart =  {
      series: this.salesDataGraph,
      chart: {
        type: "bar",
        height: 550,
        stacked: true,
        toolbar: {
          show: true
        },
        zoom: {
          enabled: true
        }
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0
            }
          }
        }
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: 'center', // top, center, bottom
            orientation: 'vertical', // horizontal, vertical
          },
        }
      },
      xaxis: {
        type: "category",
        categories: this.categories

      },
      legend: {
        position: "right",
        offsetY: 40
      },
      dataLabels: {
        enabled: this.showDataLabels,
        style: {
          fontSize: '12px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 'lighter',
          colors: ["#fff"]
        }
      },
      fill: {
        opacity: 1
      }
    };

  }
  
}
